import { BaseRouteService } from "core/services";

class ProductRouteService extends BaseRouteService {
    constructor() {
        super("products");
    }

    find(filter) {
        return super.find(
            this.base +
                "/{?searchQuery,page,rpp,sort,embed,fields,itemCategoryId,itemId,procedureCodeId,itemName,isTemplateDropdown,isActive,showPumps,unitOfMeasureIdToExclude,defaultItemTypeId,pumpBrandId,itemIds,subCategoryIdToExclude,itemTypeId,isPreferred,woundLength,woundWidth,isWoundCare,excludedUoMs}",
            filter
        );
    }

    get(id, options) {
        return super.get(this.base + "/{id}/{?embed,fields}", id, options);
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(this.base + "/{id}", resource);
    }

    delete(resource) {
        return super.delete(this.base + "/{id}", resource);
    }

    getPumps() {
        return super.get(this.base + "/pumps");
    }

    getEachProduct(productId) {
        return super.get(this.base + "/existing/{productId}", null, {
            productId: productId,
        });
    }

    copyProduct(id) {
        return super.get(this.base + "/copy-product/{id}", null, {
            id: id,
        });
    }

    download(filter) {
        return super.find(
            this.base +
                "/download/{?searchQuery,sort,inActive,itemCategoryId,itemId,itemName,procedureCodeId,showPumps}",
            filter
        );
    }

    upload(resource) {
        return super.create(this.base + "/upload", resource);
    }
}

export default ProductRouteService;
